export default __webpack_public_path__ + "static/media/OCB.15ace343.png";